
<section class="pb-0" id="iq-pricing" >
<div class="row justify-content-center position-relative">
    <div class="col-lg-8">
        <app-v-two-section-title [titleSectionProp]="titleSectionProp"></app-v-two-section-title>
    </div>
    <section class="pt-0">
        <div class="container">
            <div *ngFor="let list of List" class="row align-items-center {{ list.class != undefined && list.class ? list.class : ''  }}" style="padding: 5px;">
                <div class="col-lg-6">
                    <img class="img-fluid" src="{{ list.image }}" alt="img">
                </div>
                <div class="col-lg-6">
                    <div class="fancy-list-box  wow fadeInUp  text-left">
                        <div class="fancy-list-img {{ list.hoverClass }}">
                            <img [src]="list.price" alt="">
                        </div>
                        <div class="service-detail align-self-center">
                            <h4 class="mb-2">{{ list.title }}</h4>
                            <p>{{ list.description }}</p>
                            <div class="text-left">
                                <ul class="iq-list mb-5">
                                    <li *ngFor="let service of list.services">
                                        <i [ngClass]="service.icon"></i>
                                        <span>{{ service.title }}</span>
                                    </li>
                                </ul>
                                <!-- <a class="button blue-btn gradient-btn button-icon" href="#"><span class="btn-effect"> Empezar ahora</span></a> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 text-center" *ngIf="list.arrow_image">
                    <img class="img-fluid" src="{{ list.arrow_image }}" alt="img">
                </div>
            </div>
        </div>
    </section>
</div>
</section>



